import React, { useEffect, useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { adminGetUserNameApi } from '../../../api/admin/user';
import { adminGetCounselListApi } from '../../../api/admin/counsel';
import { useAdminStore } from '../../../store/userStore';
import { swalErrorAlert } from '../../../utils/swal/swal';
import { SearchForm } from '../common/SearchForm';
import TablePagination from '../../../components/common/TablePagination';
import AdminFileManage from '../../../components/admin/schoolRecord/AdminFileManage';

const AdminCounselList = () => {
    const { adminInfo } = useAdminStore(state => state)
    const adminType = adminInfo?.type ? adminInfo?.type : ''

    const location = useLocation();
    const pathname = location.pathname
    const params = new URLSearchParams(location.search);
    const searchTerm = params.get('search') ? params.get('search').toString() : ''

    const { userId } = useParams()

    const [userName, setUserName] = useState('')
    const [tab, setTab] = useState('counsel')


    useEffect(() => {
        getUserName(userId)
    }, [])

    const getUserName = async (userId) => {
        if (!userId) {
            setUserName('')
            return
        }

        try {
            const response = await adminGetUserNameApi(userId)

            if (response.data?.code === 200) {
                const userName = response.data?.resData?.user_name
                setUserName(userName)
            } else {
                setUserName('')
            }
            return

        } catch (error) {
            setUserName('')
            swalErrorAlert()
            return
        }
    }

    return (
        <div className="container-fluid">
            {/* Page Heading */}
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0">상담내용 관리</h1>
            </div>

            {/* Page Tab */}
            <div className='mb-5'>
                <ul className="nav nav-pills">
                    <li className="nav-item">
                        <button type='button'
                            className={tab === 'counsel' ? 'nav-link active' : 'nav-link'}
                            onClick={() => { setTab('counsel') }
                            }>상담 리스트</button>
                    </li>
                    <li className="nav-item">
                        <button type='button'
                            className={tab === 'file' ? 'nav-link active' : 'nav-link'}
                            onClick={() => { setTab('file') }}
                        >상담 관련 파일 관리(학생업로드)</button>
                    </li>
                </ul>
            </div>

            {/* Content Row */}
            <div className="card shadow mb-4">

                <div className="card-header py-3">
                    <div className='d-flex justify-content-between align-items-center'>
                        <h6 className="m-0 font-weight-bold">
                            <b className='me-2'>{userName}</b> 학생
                            {tab === 'counsel' && ' 상담 리스트'}
                            {tab === 'file' && ' 상담 관련 파일 관리'}
                        </h6>

                        {tab !== 'file' &&
                            <SearchForm pathname={pathname} searchTerm={searchTerm} placeHolder={'내용을 검색해 주세요.'} />
                        }
                    </div>
                </div>

                <div className="card-body" style={{ height: "calc(100vh - 500px)", overflow: "auto" }}>
                    {tab === 'counsel' && <CounselList userId={userId} searchTerm={searchTerm} adminType={adminType} adminId={adminInfo.user_id} />}
                    {tab === 'file' && <AdminFileManage userId={userId} fileType={'counsel'} />}

                </div>

                <div className='card-footer'>
                    <div className='text-end'>
                        <Link to={`/hy-admin/counsel`} className='btn btn-secondary'>학생 리스트로 이동</Link>
                        {['teacher', 'admin'].includes(adminType) && (
                            <Link to={`/hy-admin/counsel/write/${userId}`} className='btn btn-primary ms-2'>상담내용 작성</Link>
                        )}

                    </div>
                </div>

            </div>
        </div>
    )
}

/* 학생 리스트 */
const CounselList = ({ userId, searchTerm, adminType, adminId }) => {

    /* States */
    const [counselList, setCounselList] = useState([]) // 상담 리스트

    /* UseEffect */
    useEffect(() => {
        getCounselList(userId, searchTerm)
    }, [userId, searchTerm])

    /* Methods */
    const getCounselList = async (userId, searchTerm) => {
        try {
            const response = await adminGetCounselListApi(userId, searchTerm)

            if (response.data.code === 200) {
                const counselList = response.data.resData
                setCounselList(counselList)
            }
        } catch (error) {
            swalErrorAlert()
            setCounselList([])
        }
    }

    /* Pagination */
    const itemsPerPage = 10
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = counselList.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(counselList.length / itemsPerPage);
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % counselList.length;
        setItemOffset(newOffset);
    };

    return (
        <table className='table table-bordered align-middle' style={{ tableLayout: "fixed" }}>
            <colgroup>
                <col width={"80px"} />
                <col width={"600px"} />
                <col width={"200px"} />
                <col width={"200px"} />
                <col width={"150px"} />
            </colgroup>
            <thead>
                <tr className='table-secondary'>
                    <th>번호</th>
                    <th>제목</th>
                    <th>작성자</th>
                    <th>작성일</th>
                    <th></th>
                </tr>

            </thead>
            <tbody>
                {currentItems &&
                    currentItems.map((counsel, idx) => {
                        let no = counselList.length - itemOffset - idx;
                        return (
                            <CounselListItem key={'counselList-' + counsel.counsel_id} counselProp={counsel} no={no} adminType={adminType} adminId={adminId} />
                        )
                    })
                }

                {counselList.length === 0 && (
                    searchTerm === '' ? (
                        <tr>
                            <td colSpan={5}>
                                <p className='py-3 text-center'>작성된 상담내용이 없습니다.</p>
                            </td>
                        </tr>
                    )
                        : (
                            <tr>
                                <td colSpan={5}>
                                    <p className='py-3 text-center lh-lg'>
                                        검색어: <b>{searchTerm}</b> <br />
                                        검색된 상담내용이 없습니다.
                                    </p>
                                </td>
                            </tr>
                        )
                )}
            </tbody>

            <tfoot>
                <tr>
                    <td colSpan={4}>
                        <div className='text-center'>
                            <TablePagination handlePageClick={handlePageClick} pageCount={pageCount} />
                        </div>
                    </td>
                </tr>
            </tfoot>

        </table>
    )

}

const CounselListItem = ({ counselProp, no, adminType, adminId }) => {
    const counsel = counselProp ? counselProp : null

    return (
        <tr>
            <td>{no}</td>
            <td style={{ wordBreak: "break-all" }}>{counsel.title}</td>
            <td>{counsel.writer_name}</td>
            <td>{counsel.date}</td>
            <td className='text-center'>
                <Link to={`/hy-admin/counsel/read/${counsel.user_id}/${counsel.counsel_id}`} className='btn btn-outline-secondary btn-sm'>조회</Link>
                {
                    (['teacher', 'admin'].includes(adminType) && adminId === counsel.writer_id) &&
                    <Link to={`/hy-admin/counsel/update/${counsel.user_id}/${counsel.counsel_id}`} className='btn btn-primary btn-sm ms-2'>수정</Link>
                }
            </td>
        </tr>
    )
}

export default AdminCounselList